import { render, staticRenderFns } from "./TcoGraphTab.vue?vue&type=template&id=00514893"
import script from "./TcoGraphTab.vue?vue&type=script&lang=js"
export * from "./TcoGraphTab.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports